module.exports = __webpack_public_path__ + "img/n3.e47e484d.jpg";